import { TextProps } from "@fluentui/react-components";

export const FontSizeRecord = {
    ["10"]: 100,
    ["12"]: 200,
    ["14"]: 300,
    ["16"]: 400,
    ["20"]: 500,
    ["24"]: 600,
    ["28"]: 700,
    ["32"]: 800,
    ["40"]: 900,
    ["68"]: 1000
} as const;

export type FontSizeKeys = keyof typeof FontSizeRecord;

export type M365PulseTextProps = TextProps & {
    /**
     * Applies font size and line height based on the theme typography tokens.
     * It has higher priority than 'size'
     */
    fontSize?: FontSizeKeys;
};
